'use client';

import { Checkbox } from '@/shared/shadcn/ui/checkbox';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem } from '@/shared/shadcn/ui/command';
import { ScrollArea } from '@/shared/shadcn/ui/scroll-area';
import { CommandList } from 'cmdk';

export function MultiSelect<T extends { id: string; title: string }>({
  values = [],
  options,
  placeholder = 'Поиск тегов...',
  notFound = 'Тег не найден',
  searchable,
  onChange,
}: {
  values?: T[];
  options: T[];
  placeholder?: string;
  notFound?: string;
  searchable?: boolean;
  onChange: (values: T[]) => void;
}) {
  const handleChange = (values: T[] = []) => {
    onChange(values);
  };

  return (
    <Command>
      {searchable && <CommandInput placeholder={placeholder} />}
      <CommandList>
        {searchable && <CommandEmpty>{notFound}</CommandEmpty>}
        <CommandGroup>
          <ScrollArea className="max-h-96 overflow-y-scroll">
            {options.map((tag) => (
              <CommandItem
                key={tag.id}
                onSelect={() => {
                  handleChange(
                    values.some((t) => t.id === tag.id) ? values.filter((t) => t.id !== tag.id) : [...values, tag],
                  );
                }}
              >
                <Checkbox checked={values.some((t) => t.id === tag.id)} className="mr-2 h-4 w-4" />
                {tag.title}
              </CommandItem>
            ))}
          </ScrollArea>
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
